<template>
  <div>
    <!--S 右侧区域-->
    <!-- <transition name="slide-right"> -->
      <router-view></router-view>
    <!-- </transition> -->
    <!--E 右侧区域-->
  </div>
</template>
<script>
export default {
  name: 'Templent_Delivery',
  data () {
    return {

    }
  },
  filters: {

  },
  components: {

  },
  methods: {

  },
  created() {
    
  },
  watch: {

  },
  mounted () {


  },
  computed: {}
}
</script>

<style scoped>
@import "Css/Style.css";
@import "./Css/Style.css";
</style>



// WEBPACK FOOTER //
// src/views/DeliveryFolder/Templent_Delivery.vue